<script setup>
setPageTitle(PageMeta.Orders.service.title)
definePage({ meta: PageMeta.Orders.service.meta })

import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { Subject } from '@/@vxapp/@Enums/PHP/Auth/Ability/Subjects/DataProviders/AbilitySubject'
import { ServiceType } from '@/@vxapp/@Enums/ServiceType'
import OrdersServicePage from '@/views/Previews/Orders/OrdersServicePage.vue'
import { useRoute } from 'vue-router'

const route = useRoute()

/* ** */
</script>

<template>
  <div
    class="preview-service-wrapper"
    data-testid="service-page-root"
    :data-service-type="ServiceType.Orders.Name"
  >
    <OrdersServicePage
      :order-g-u-i-d="route.params.guid"
      :allow-changes="false"
      :read-subject="Subject.ORDERS_PREVIEW_SERVICE"
    />
  </div>
</template>
